<nav class="navbar navbar-expand-lg nav-crev" [class.nav-scroll]="isSticky"
  [ngClass]="{'dir-rtl': selectedLanguage === 'ar'}">
  <div class="container">
    <a class="navbar-brand icon-img-100" [routerLink]="business ? '/' + business.id : '/'">
      <img [src]="getLogoUrl(business?.logo)" alt="{{business?.name || 'Logo'}}" class="logo">
    </a>

    <button class="navbar-toggler ms-auto" type="button" (click)="isCollapsed = !isCollapsed" data-bs-toggle="collapse"
      data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false"
      aria-label="Toggle navigation">
      <span class="icon-bar"><i class="icofont icofont-navigation-menu"></i></span>
    </button>

    <div class="collapse navbar-collapse" [ngClass]="{'collapse': isCollapsed, 'navbar-collapse': true}"
      id="navbarNavAltMarkup">
      <ul class="navbar-nav navbar-center xs-mt-20">
        <li class="nav-item">
          <a class="nav-link" (click)="scrollToSection('home')">
            {{ languageService.getTranslation('home') }}
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" (click)="scrollToSection('services')">
            {{ languageService.getTranslation('services') }}
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" (click)="scrollToSection('about')">
            {{ languageService.getTranslation('about') }}
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" (click)="scrollToSection('contact')">
            {{ languageService.getTranslation('contact') }}
          </a>
        </li>
      </ul>

      <div class="nav-button ms-auto xs-ml-0 xs-mt-20">
        <ul class="nav navbar-nav navbar-right d-flex align-items-center">
          <li>
            <!-- Single branch — direct link -->
            <a *ngIf="!hasMultipleBranches" [href]="menuUrl" target="_blank" class="btn btn-lg btn-circle" [ngClass]="{
       'bg-home-three text-white': business?.template_id === 'home-three',
       'bg-home-five text-white': business?.template_id === 'home-five',
       'bg-home-six text-white': business?.template_id === 'home-six',
       'bg-home-two text-white': business?.template_id === 'home-two',
       'bg-home-one text-white': business?.template_id === 'home-one',
       'bg-home-four text-white': business?.template_id === 'home-four',
       'btn-gradient-primary': !business?.template_id
     }">
              {{ languageService.getTranslation('checkTheMenu') }}
            </a>

            <!-- Multiple branches — dropdown -->
            <div *ngIf="hasMultipleBranches" class="menu-multi-wrapper">
              <!-- Desktop: hover dropdown -->
              <!-- NEW: -->
              <div class="menu-dropdown-desktop">
                <button class="btn btn-lg btn-circle dropdown-trigger-btn" [ngClass]="{
      'bg-home-three text-white': business?.template_id === 'home-three',
      'bg-home-five text-white': business?.template_id === 'home-five',
      'bg-home-six text-white': business?.template_id === 'home-six',
      'bg-home-two text-white': business?.template_id === 'home-two',
      'bg-home-one text-white': business?.template_id === 'home-one',
      'bg-home-four text-white': business?.template_id === 'home-four',
      'btn-gradient-primary': !business?.template_id
    }" (click)="toggleMenuDropdown($event)">
                  {{ languageService.getTranslation('checkTheMenu') }}
                  <i class="icofont ms-1"
                    [ngClass]="showMenuDropdown ? 'icofont-rounded-up' : 'icofont-rounded-down'"></i>
                </button>
                <div class="branches-dropdown" *ngIf="showMenuDropdown">
                  <a *ngFor="let branch of menuBranches" [href]="branch.url" target="_blank" class="branch-item">
                    {{ branch.name }}
                  </a>
                </div>
              </div>

              <!-- Mobile: click to toggle -->
              <div class="menu-dropdown-mobile d-none">
                <button class="btn btn-lg btn-circle" [ngClass]="{
                'bg-home-three text-white': business?.template_id === 'home-three',
                'bg-home-five text-white': business?.template_id === 'home-five',
                'bg-home-six text-white': business?.template_id === 'home-six',
                'bg-home-two text-white': business?.template_id === 'home-two',
                'bg-home-one text-white': business?.template_id === 'home-one',
                'bg-home-four text-white': business?.template_id === 'home-four',
                'btn-gradient-primary': !business?.template_id
              }" (click)="showMenuDropdown = !showMenuDropdown">
                  {{ languageService.getTranslation('checkTheMenu') }}
                  <i class="icofont icofont-rounded-down ms-1"></i>
                </button>
                <div class="branches-dropdown mobile" *ngIf="showMenuDropdown">
                  <a *ngFor="let branch of menuBranches" [href]="branch.url" target="_blank" class="branch-item">
                    {{ branch.name }}
                  </a>
                </div>
              </div>
            </div>
          </li>

          <!-- LANGUAGE SELECTOR -->
          <li class="nav-item language-selector-wrapper">
            <div class="dropdown">
              <button type="button" class="language-selector-btn" id="languageDropdown" data-bs-toggle="dropdown"
                aria-expanded="false">
                <i class="icofont icofont-world language-icon"></i>
                <span class="language-text">{{ selectedLanguage.toUpperCase() }}</span>
                <i class="icofont icofont-rounded-down dropdown-arrow"></i>
              </button>
              <ul class="dropdown-menu dropdown-menu-end language-dropdown" aria-labelledby="languageDropdown">
                <li *ngFor="let opt of languageOptions">
                  <a class="dropdown-item language-option" [class.active]="selectedLanguage === opt.value"
                    (click)="onLanguageChange(opt.value)">
                    <span class="option-label">{{ opt.label }}</span>
                    <i class="icofont icofont-check check-icon" *ngIf="selectedLanguage === opt.value"></i>
                  </a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</nav>